<div class="container-fluid body">
  <div class='row'>
    <div style="padding-left: 0; padding-right: 0;">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
